if (!window.__compareItemsInitialized) {
  window.__compareItemsInitialized = true;

document.addEventListener('DOMContentLoaded', function() {
  const compare_popup = document.querySelector('.compare-fabric-popup');
  if (!compare_popup) {
    return;
  }

  let lastXTransformPosition = 0;
  let currentOpenPopupContainer = null;
  const multiCloseElements = compare_popup.querySelectorAll('[class*="multi-close-"]');
  const compare_left_column = document.querySelector('#cc-compare-item-left-column-id');
  const compare_right_column = compare_popup.querySelector('.no-gutter-layout .column--55');

  function getParentNodeByType(node, type) {
    while ((node = node.parentElement)) {
      if (node.tagName === type.toUpperCase()) return node;
    }
    return null;
  }

  const compare_buttons = compare_popup.querySelectorAll('.compare-item-button');
  const compare_preview_image = document.querySelector('#cc-compare-fabric-preview');
  const compare_panels = compare_popup.querySelectorAll('[data-compare-fabric-index]');
  let backgroundLoadId = 0;
  let waitIntervalId = null;

  // The popup is hidden with visibility:hidden on a position:fixed element covering the
  // viewport, so it stays laid out and inside the intersection rectangle. loading="lazy" is
  // therefore inert here -- measured on the deployed theme, the preview downloads during the
  // initial page load on every product view, whether or not anyone opens Compare. The real
  // src lives in data-src instead, and is promoted on first intent towards the trigger (the
  // same pattern as warmMega in header.js) so the request is in flight before the popup is
  // displayed. click is in the list as the backstop: at worst the fetch starts exactly when
  // the popup opens, which is no later than the old behaviour.
  function warmComparePreview() {
    if (!compare_preview_image || compare_preview_image.dataset.warmed) {
      return;
    }
    compare_preview_image.dataset.warmed = 'true';
    if (compare_preview_image.dataset.srcset) {
      compare_preview_image.srcset = compare_preview_image.dataset.srcset;
    }
    if (compare_preview_image.dataset.src) {
      compare_preview_image.src = compare_preview_image.dataset.src;
    }
  }

  document
    .querySelectorAll('[data-modal-id="nugget-notify-form-popup-compare-fabrics"]')
    .forEach(function(trigger) {
      ['pointerenter', 'focusin', 'touchstart', 'click'].forEach(function(evt) {
        trigger.addEventListener(evt, warmComparePreview, { once: true, passive: true });
      });
    });

  function syncCompareLeftColumnHeight() {
    if (!compare_left_column || !compare_right_column) {
      return;
    }
    compare_left_column.style.height = compare_right_column.offsetHeight + 'px';
  }

  function scheduleCompareHeightSync() {
    requestAnimationFrame(function() {
      syncCompareLeftColumnHeight();
      requestAnimationFrame(syncCompareLeftColumnHeight);
    });
  }

  if (compare_left_column && compare_right_column && 'ResizeObserver' in window) {
    const compareHeightObserver = new ResizeObserver(function() {
      syncCompareLeftColumnHeight();
    });
    compareHeightObserver.observe(compare_right_column);
  }

  compare_popup.addEventListener('transitionend', function(event) {
    if (event.target.matches('.cc-accordion-item__panel')) {
      scheduleCompareHeightSync();
    }
  });

  function clearCompareWaitIndicators() {
    if (waitIntervalId) {
      clearInterval(waitIntervalId);
      waitIntervalId = null;
    }
    compare_popup.querySelectorAll('.cc-popup-fabric-circles-wait-indicator').forEach(function(indicator) {
      indicator.classList.add('hidden');
    });
  }

  function getComparePanelFromDetails(detailsEl) {
    if (!detailsEl) {
      return null;
    }

    const contentEl = detailsEl.querySelector('[class*="multi-close-"]');
    if (!contentEl) {
      return null;
    }

    const match = contentEl.className.match(/multi-close-(\d+)/);
    if (!match) {
      return null;
    }

    const panelIndex = parseInt(match[1], 10) - 1;
    return compare_panels[panelIndex] || null;
  }

  // imageSrcset is the density-descriptor set for the swatch. Passing an empty value pins the
  // element to imageUrl alone -- without that, a stale srcset would keep winning over src and
  // the preview would never change when a different fabric is picked.
  function setComparePreviewImage(imageUrl, imageSrcset) {
    if (!compare_preview_image || !imageUrl) {
      return false;
    }

    if (imageSrcset) {
      compare_preview_image.srcset = imageSrcset;
    } else {
      compare_preview_image.removeAttribute('srcset');
    }
    compare_preview_image.src = imageUrl;
    return true;
  }

  function loadCompareBackground(compare_button) {
    if (!compare_button) {
      return;
    }

    const imageUrl = compare_button.dataset.productBackgroundSwatch;
    const imageSrcset = compare_button.dataset.productBackgroundSwatchSrcset || '';
    if (!imageUrl) {
      return;
    }

    const loadId = ++backgroundLoadId;
    const wait_indicator = compare_button.querySelector('.cc-popup-fabric-circles-wait-indicator');

    clearCompareWaitIndicators();
    setComparePreviewImage(imageUrl, imageSrcset);

    if (wait_indicator) {
      waitIntervalId = setInterval(function() {
        wait_indicator.classList.remove('hidden');
      }, 250);
    }

    const compare_image = new Image();
    const finishLoad = function() {
      if (loadId !== backgroundLoadId) {
        return;
      }
      clearCompareWaitIndicators();
      // currentSrc is the candidate the browser actually picked, so pin it and drop the srcset.
      setComparePreviewImage(compare_image.currentSrc || compare_image.src || imageUrl, '');
    };

    compare_image.onload = finishLoad;
    compare_image.onerror = function() {
      if (loadId !== backgroundLoadId) {
        return;
      }
      clearCompareWaitIndicators();
    };
    if (imageSrcset) {
      compare_image.srcset = imageSrcset;
    }
    compare_image.src = imageUrl;

    if (compare_image.complete) {
      finishLoad();
    }
  }

  function getVisibleComparePanel() {
    return compare_popup.querySelector('[id^="item_compare_"]:not(.hidden)');
  }

  function getComparePanelFromNode(node) {
    let current = node;
    while (current && current !== compare_popup) {
      if (current.id && current.id.indexOf('item_compare_') === 0) {
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  function updateCompareArrowsVisibility(panelElement) {
    if (!panelElement) {
      return;
    }

    const arrows = panelElement.querySelector('.compare-item-arrows');
    const scrollContainer = panelElement.querySelector('.compare-item-container');
    const scrollList = panelElement.querySelector('.compare-item-list');
    if (!arrows || !scrollContainer || !scrollList) {
      return;
    }

    const buttons = scrollList.querySelectorAll('.compare-item-button');
    const needsArrows = buttons.length >= 4 && scrollList.scrollWidth > scrollContainer.clientWidth + 1;

    arrows.classList.toggle('js-hidden', !needsArrows);
    scrollList.style.transform = needsArrows ? scrollList.style.transform : 'translateX(0px)';

    if (!needsArrows) {
      lastXTransformPosition = 0;
    }
  }

  function closeCompareAccordionDetails(detailsEl) {
    if (!detailsEl) {
      return;
    }

    detailsEl.classList.remove('is-open', 'is-closing');
    detailsEl.open = false;

    const panel = detailsEl.querySelector('.cc-accordion-item__panel');
    if (panel) {
      panel.removeAttribute('style');
    }
  }

  function showCompareFabricPanel(panelElement) {
    if (!panelElement) {
      return null;
    }

    compare_popup.querySelectorAll('[id^="item_compare_"]').forEach(function(element) {
      element.classList.toggle('hidden', element !== panelElement);
    });

    const firstButton = panelElement.querySelector('.compare-item-list .compare-item-button');
    if (!firstButton) {
      return null;
    }

    compare_buttons.forEach(function(button) {
      button.classList.toggle('active', button === firstButton);
    });
    loadCompareBackground(firstButton);
    updateCompareArrowsVisibility(panelElement);
    scheduleCompareHeightSync();
    return firstButton;
  }

  function findFirstVisibleElement(parentElement, containerElement) {
    const childElements = parentElement.children;
    const containerRect = containerElement.getBoundingClientRect();
    for (let i = 0; i < childElements.length; i++) {
      const child = childElements[i];
      if (isElementVisible(child, containerRect)) {
        return child;
      }
    }
    return null;
  }

  function isElementVisible(element, containerRect) {
    const elementRect = element.getBoundingClientRect();
    return (
      elementRect.left >= containerRect.left &&
      elementRect.right <= containerRect.right &&
      elementRect.top >= containerRect.top &&
      elementRect.bottom <= containerRect.bottom
    );
  }

  function processButtonStage(node, event) {
    const self = node;
    let parentElement = null;
    let isEventContext = true;

    if (event != null && typeof event == 'object' && event.type == 'click') {
      parentElement = self.parentElement.parentElement;
    } else {
      parentElement = self.parentElement.parentElement.parentElement;
      isEventContext = false;
    }

    if (!parentElement) {
      return;
    }

    const panelElement = getComparePanelFromNode(parentElement);
    if (!panelElement) {
      return;
    }

    updateCompareArrowsVisibility(panelElement);

    const scrollContainer = panelElement.querySelector('[class*="compare-item-container"]');
    const scrollList = scrollContainer ? scrollContainer.querySelector('[class*="compare-item-list"]') : null;
    const buttons = scrollList ? scrollList.querySelectorAll('button') : [];
    const arrowsElement = panelElement.querySelector('.compare-item-arrows');

    if (!scrollContainer || !scrollList || !arrowsElement || arrowsElement.classList.contains('js-hidden') || buttons.length < 4) {
      return false;
    }

    let leftArrowButton = null;
    let rightArrowButton = null;
    let arrowSelectionDirection = null;

    if (isEventContext && self.classList.contains('button-left')) {
      leftArrowButton = self;
      rightArrowButton = arrowsElement.querySelector('[class*="button-right"]');
      arrowSelectionDirection = +1;
    } else if (isEventContext && self.classList.contains('button-right')) {
      leftArrowButton = arrowsElement.querySelector('[class*="button-left"]');
      rightArrowButton = self;
      arrowSelectionDirection = -1;
    } else if (!isEventContext) {
      leftArrowButton = arrowsElement.querySelector('[class*="button-left"]');
      rightArrowButton = arrowsElement.querySelector('[class*="button-right"]');
    }

    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    if (!buttons || buttons.length == 0) {
      return;
    }
    const firstElement = buttons.length > 0 ? buttons[0] : null;
    const lastElement = buttons.length > 0 ? buttons[buttons.length - 1] : null;
    if (!firstElement && !lastElement) {
      return false;
    }

    const firstVisibleElement = findFirstVisibleElement(scrollList, scrollContainer);
    if (!firstVisibleElement || (firstVisibleElement == lastElement && arrowSelectionDirection == -1)) {
      return false;
    }
    const isLastElementVisible = isElementVisible(lastElement, scrollContainerRect);
    if (firstElement == firstVisibleElement && isLastElementVisible == true) {
      leftArrowButton.classList.add('js-hidden');
      rightArrowButton.classList.add('js-hidden');
    }

    const currentSelectedElement = scrollList.querySelector('.active');
    let nextSelectedElement = null;
    let nextNodeInList = null;

    if (!isEventContext && currentSelectedElement == firstElement && currentSelectedElement.nextElementSibling) {
      nextSelectedElement = firstElement;
      arrowSelectionDirection = 1;
    } else if (!isEventContext && currentSelectedElement == lastElement && currentSelectedElement.previousElementSibling) {
      nextSelectedElement = currentSelectedElement;
      arrowSelectionDirection = -1;
    } else if (!isEventContext && isElementVisible(currentSelectedElement.previousElementSibling, scrollContainerRect)) {
      nextSelectedElement = currentSelectedElement;
      arrowSelectionDirection = -1;
    } else if (!isEventContext && isElementVisible(currentSelectedElement.nextElementSibling, scrollContainerRect)) {
      nextSelectedElement = currentSelectedElement;
      arrowSelectionDirection = 1;
    } else {
      if (arrowSelectionDirection == 1) {
        nextNodeInList = currentSelectedElement.previousElementSibling;
      } else {
        nextNodeInList = currentSelectedElement.nextElementSibling;
      }

      while (nextNodeInList) {
        if (nextNodeInList.tagName === 'BUTTON') {
          nextSelectedElement = nextNodeInList;
          break;
        }
        nextNodeInList = (arrowSelectionDirection == 1) ? nextNodeInList.previousElementSibling : nextNodeInList.nextElementSibling;
      }

      if (nextSelectedElement == null) {
        nextSelectedElement = findFirstVisibleElement(scrollList, scrollContainer);
      }
    }

    if (!isElementVisible(nextSelectedElement, scrollContainerRect)) {
      const newScrollPosition = lastXTransformPosition + parseFloat(arrowSelectionDirection * (nextSelectedElement.offsetWidth + 4));
      if (newScrollPosition <= 0) {
        lastXTransformPosition = newScrollPosition;
      } else {
        lastXTransformPosition = 0;
      }
      scrollList.style.transform = (newScrollPosition <= 0) ? 'translateX(' + newScrollPosition + 'px)' : 'translateX(0px)';
    }

    if (!nextSelectedElement) {
      return;
    }

    if (firstElement == nextSelectedElement) {
      leftArrowButton.classList.add('disabled');
    } else {
      leftArrowButton.classList.remove('disabled');
    }

    if (lastElement == currentSelectedElement || lastElement == nextSelectedElement) {
      rightArrowButton.classList.add('disabled');
    } else {
      rightArrowButton.classList.remove('disabled');
    }

    if (isEventContext && (currentSelectedElement != lastElement || (currentSelectedElement == lastElement && arrowSelectionDirection == 1))) {
      nextSelectedElement.click();
    }

    return true;
  }

  function setupModalObserver() {
    const modals = compare_popup.querySelectorAll('[id^="item_compare_"]');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          if (!mutation.target.classList.contains('hidden') && currentOpenPopupContainer != mutation.target) {
            currentOpenPopupContainer = mutation.target;
            const localFirstButton = mutation.target.querySelector('.compare-item-list .compare-item-button');
            if (localFirstButton) {
              processButtonStage(localFirstButton, null);
              updateCompareArrowsVisibility(mutation.target);
              scheduleCompareHeightSync();
            }
          }
        }
      });
    });

    const config = {
      attributes: true,
      attributeFilter: ['class']
    };

    modals.forEach(modal => {
      observer.observe(modal, config);
    });
  }

  compare_buttons.forEach(compare_button => {
    compare_button.addEventListener('click', function() {
      compare_buttons.forEach(function(button) {
        button.classList.toggle('active', button === compare_button);
      });
      processButtonStage(compare_button, false);
      loadCompareBackground(compare_button);
      scheduleCompareHeightSync();
    });
  });

  multiCloseElements.forEach(element => {
    const detailsEl = getParentNodeByType(element, 'DETAILS');
    if (!detailsEl) {
      return;
    }

    detailsEl.addEventListener('toggle', function() {
      const self = this;

      if (self.open) {
        const targetPanel = getComparePanelFromDetails(self);
        if (targetPanel) {
          showCompareFabricPanel(targetPanel);
        } else {
          const containerSingleLineNode = self.querySelector('.metafield-single_line_text_field');
          const containerSingleLineNodeName = containerSingleLineNode ? containerSingleLineNode.textContent.trim() : '';
          const fallbackPanel = containerSingleLineNodeName
            ? document.getElementById('item_compare_' + containerSingleLineNodeName.toUpperCase())
            : null;
          if (fallbackPanel) {
            showCompareFabricPanel(fallbackPanel);
          }
        }

        compare_popup.querySelectorAll('details.cc-accordion-item[open]').forEach(function(openDetail) {
          if (openDetail !== self) {
            closeCompareAccordionDetails(openDetail);
          }
        });
      }

      lastXTransformPosition = 0;
      scheduleCompareHeightSync();
    });
  });

  compare_popup.querySelectorAll('.compare-button').forEach(arrow => {
    arrow.addEventListener('click', function(event) {
      processButtonStage(this, event);
    });
  });

  window.addEventListener('resize', function() {
    updateCompareArrowsVisibility(getVisibleComparePanel());
  });

  setupModalObserver();
  updateCompareArrowsVisibility(getVisibleComparePanel());
  scheduleCompareHeightSync();
});
}
